import { createStore } from '../_core/createStore';
import { workflowStore } from './workflowStore';

const useWorkflowStore = createStore({
  creator: workflowStore,
  id: 'workflow',
  middlewares: {
    devtools: true,
  },
});

export default useWorkflowStore;
